module.exports = __webpack_public_path__ + "media/images/character/zen_chan_jump_l-31d86701a66f84228dffc8c50a66ab9f.png";